/**
 * @Description
 */

import { FC } from 'react';
import styles from '../entry.module.less';

const Header:FC<any> = ({ title }) => {
  return (
    <div className={styles['header']}>

      <div className={styles['left']}>
        <div className={styles['left-icon']}/>
        <div className={styles['left-content']}>
          {title}
        </div>
      </div>

      <div className={styles['right']}>
        <img src={require('@/assets/image/ppt_logo.png')} className={styles['right-logo']}/>
      </div>
    </div>
  );
};

export default Header;
